<!-- TEMPLATE -->
<template>
  <div class="wrapper sidebar-mini" :class="navbarclass">
    <ShowAlertNotification />
    <SidebarDashboard />
    <div class="main-panel">
      <Navbar @toggle_sidebar="toggleSideBar" />
      <DetailsContent />
    </div>
    <FooterDashboard />
  </div>
</template>

<!-- SCRIPT -->
<script>
import SidebarDashboard from "./Sidebar.vue";
import Navbar from "./Navbar.vue";
import DetailsContent from "./DetailsContent.vue";
import ShowAlertNotification from "./ShowAlertNotification.vue";
import FooterDashboard from "./Footer.vue";

export default {
  name: "Home",
  data: function () {
    return {
      userInfo: this.$store.state.cognitoInfo,
      navbarclass: "",
    };
  },
  methods: {
    toggleSideBar(e) {
      if (e) this.navbarclass = "nav-open";
      else this.navbarclass = "";
    },
  },
  components: {
    SidebarDashboard,
    Navbar,
    DetailsContent,
    ShowAlertNotification,
    FooterDashboard,
  },
};
</script>

<!-- Style -->
<style>
</style>